import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/pages.css';

const HowToBuyPage = () => {
  return (
    <div className="static-page">
      <h2 className="page-title">Como Comprar</h2>

      <p>Comprar na <strong>Gabrielly Semijoias</strong> é fácil, rápido e seguro! Siga os passos abaixo para adquirir suas peças favoritas.</p>

      <section>
        <h3>Passo 1: Encontre seu Produto</h3>
        <ul>
          <li>Navegue pelo nosso site usando o menu <Link to="/catalogo">Catálogo</Link> para explorar as categorias (Anéis, Brincos, Colares, etc.).</li>
          <li>Você também pode usar a barra de pesquisa no topo da página se já souber o que procura.</li>
          <li>Clique no produto que você gostou para ver mais detalhes, fotos e informações.</li>
        </ul>
      </section>

      <section>
        <h3>Passo 2: Adicione ao Carrinho</h3>
        <ul>
          <li>Na página do produto, selecione a quantidade desejada.</li>
          <li>Clique no botão <strong>"ADICIONAR AO CARRINHO"</strong>.</li>
          <li>Uma janela aparecerá confirmando que o produto foi adicionado. Você pode escolher <strong>"CONTINUAR COMPRANDO"</strong> para adicionar mais itens ou <strong>"IR PARA O CARRINHO"</strong> para finalizar a compra.</li>
        </ul>
      </section>

      <section>
        <h3>Passo 3: Carrinho de Compras</h3>
        <ul>
          <li>No seu <Link to="/carrinho">carrinho</Link>, você pode revisar todos os itens, alterar quantidades ou remover produtos.</li>
          <li>Nesta página, você também pode calcular o frete para o seu endereço digitando seu CEP.</li>
          <li>Se tiver um cupom de desconto, este é o momento de usá-lo! Insira o código no campo indicado.</li>
          <li>Quando estiver tudo certo, clique em <strong>"FINALIZAR COMPRA"</strong>.</li>
        </ul>
      </section>

      <section>
        <h3>Passo 4: Checkout - Identificação e Entrega</h3>
        <ul>
          <li>Se você já tem uma conta, faça o login. Caso contrário, será necessário preencher um breve cadastro com seu e-mail, nome e informações de contato.</li>
          <li>Preencha o endereço onde você deseja receber sua compra. Preencha todos os campos com atenção para garantir que a entrega seja feita corretamente.</li>
          <li>Escolha a modalidade de frete que preferir (por exemplo, SEDEX ou PAC).</li>
        </ul>
      </section>

      <section>
        <h3>Passo 5: Pagamento</h3>
        <ul>
          <li>Escolha a forma de pagamento que preferir:
            <ul>
              <li><strong>Cartão de Crédito:</strong> Preencha os dados do seu cartão. Você pode parcelar em até 10x.</li>
              <li><strong>Pix:</strong> Um código QR será gerado para você realizar o pagamento.</li>
              <li><strong>Boleto Bancário:</strong> O boleto será gerado com uma data de vencimento para pagamento.</li>
            </ul>
          </li>
          <li>Revise todas as informações do seu pedido pela última vez.</li>
          <li>Clique em <strong>"FINALIZAR PEDIDO"</strong>.</li>
        </ul>
      </section>

      <section>
        <h3>Pronto!</h3>
        <p>Você receberá um e-mail com a confirmação e todos os detalhes do seu pedido. Assim que o pagamento for aprovado e o pedido for enviado, nós te avisaremos por e-mail com o código de rastreamento.</p>
        <p><strong>Boas compras!</strong></p>
      </section>
    </div>
  );
};

export default HowToBuyPage;
